import { message, Modal, Table, Button, Pagination, Tabs } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { formatNumber,  checkp } from '../../utils/functions'
import renderFileList from "../../components/renderFileList";
import ShEditor from "../../components/ShEditor";

function Tbsh() {
    const { type } = useParams();
    const webPost = useWebPost();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [activeKey, setActiveKey] = useState('0');

    const pageSizeOptions = [10, 20, 50, 100, 500];
    const [editingRecord, setEditingRecord] = useState(null);

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = async () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            let res = [], tos = 0;
            try {
                const params = { type, s: activeKey, page: currentPage, limit: pageSize };
                const response = await webPost('tbshb', params);
                if (response) {
                    res = response;
                }
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
            setData(res);
            setTotal(tos);
        }
        fetchItems();
    }, [currentPage, pageSize,  freshData, activeKey, type]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80, fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '年份', dataIndex: 'co_date', width: 120 },
        { title: '项目编号', dataIndex: 'sn', width: 120 },
        { title: '项目名称', dataIndex: 'xmmc', width: 120, ellipsis: { showTitle: true, } },
        { title: '招标单位/招标代理机构', dataIndex: 'xmdjxx1', width: 160, ellipsis: { showTitle: true, } },
        { title: '投标保证金', dataIndex: 'tbbzj', width: 120 },
        {
            title: '参与/中标/自营', dataIndex: 'type', width: 120, ellipsis: { showTitle: true, }, render: (v) =>
                <div
                    style={{
                        width: '100%',
                        whiteSpace: 'pre-wrap', // 解析换行符（\n）
                        wordBreak: 'break-all', // 超长字符换行
                        lineHeight: '1.4', // 行高适配
                        padding: '2px 0', // 内边距优化
                        overflow: 'hidden' // 配合ellipsis，超出宽度隐藏
                    }}
                >
                    {v || '-'} {/* 空值显示占位符 */}
                </div>
        },
        { title: '授权委托人', dataIndex: 'wtname', width: 120, },
        { title: '项目经理', dataIndex: 'xmjl', width: 120, },
        { title: '招标文件', dataIndex: 'files', width: 100, render: (t) => renderFileList(t) },
        { title: '其它文件', dataIndex: 'files1', width: 100, render: (t) => renderFileList(t) },
        { title: '填报企业', dataIndex: 'com_tianbao', width: 120, ellipsis: { showTitle: true, }, },
        { title: '标书编制人', dataIndex: 'bsbzr', width: 120 },
        { title: '标书审核人', dataIndex: 'shnm1', width: 120, render:(_,rs)=> rs.shnm1+"_"+rs.shnm2 },
        { title: '签章审核人', dataIndex: 'shnm3', width: 120 },
        { title: '标书完成时间', dataIndex: 'shdtm', width: 120 },
        { title: '标书上传时间', dataIndex: 'updtm', width: 120 },
        { title: '投标截止时间', dataIndex: 'endtime', width: 120 },
        
        { title: '商务标书', dataIndex: 'tbfiles', width: 100, render: (t) => renderFileList(t) },
        { title: '技术标书', dataIndex: 'tbfiles1', width: 100, render: (t) => renderFileList(t) },
        { title: '其它标书', dataIndex: 'tbfiles2', width: 100, render: (t) => renderFileList(t) },
        { title: '备注', dataIndex: 'ps', width: 100, ellipsis: { showTitle: true, } },


        // { title: '业主名称', dataIndex: 'customer_name', width: 120, ellipsis: { showTitle: true, }, },
        // { title: '实际合同额(万元)', dataIndex: 'sjamount', width: 120, render: (v) => formatNumber(v / 10000) },
        // { title: '税率（%）', dataIndex: 'zylx', width: 120, },
        // { title: '项目地点', dataIndex: 'location', width: 100, ellipsis: { showTitle: true, } },
        // { title: '项目规模', dataIndex: 'xmgm', width: 100, ellipsis: { showTitle: true, } },
        // { title: '合同范围', dataIndex: 'htfw', width: 100, ellipsis: { showTitle: true, } },
        // { title: '招标范围', dataIndex: 'zbfw', width: 100, ellipsis: { showTitle: true, } },
        // { title: '预付款', dataIndex: 'amount', width: 100, ellipsis: { showTitle: true, }, render: () => '这个放哪里填写' },
        // { title: '进度款支付比例', dataIndex: 'amount', width: 100, ellipsis: { showTitle: true, }, render: () => '这个放哪里填写' },

        // { title: '履约保证金形式', dataIndex: 'sdf', width: 100, render: () => '这个放哪里填写' },
        // { title: '履约保证金', dataIndex: 'lybzj', width: 100, },
        // { title: '质保金比例', dataIndex: 'zbbzj_paytype', width: 100, },
        (checkp(['bssh1']) || checkp(['bssh2']) || checkp(['bssh3'])) && activeKey=='0' && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "scbs")} >开始审核</Button>,
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (!record) {
            message.error("错误的参数");
            return;
        }
        setEditingRecord(record);
        setModalVisible(action);
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = async (r) => {
        if (!editingRecord?.id) return message.error("错误的参数");
        const params = { id: editingRecord?.id, ad:editingRecord?.rsn,  type, s: activeKey, ...r, sn: editingRecord.sn };
        const res = await webPost('tbshbsave', params);
        if (res) {
            message.success(editingRecord ? '更新成功' : '新增成功');
            setfreshData(Math.random()); //强制刷新数据
            handleModalClose();
        }
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={null}
            bodyContent={
                <>
                    <Tabs activeKey={activeKey} onChange={setActiveKey} style={{ 'padding': '0 10px' }}>
                        <Tabs.TabPane key='0' tab='待审核'>
                        </Tabs.TabPane>
                        <Tabs.TabPane key='-1' tab='已拒绝'>
                        </Tabs.TabPane>
                        <Tabs.TabPane key='1' tab='通过审核'>
                        </Tabs.TabPane>
                    </Tabs>

                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={(record, index) => index}
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1800,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                    />
                </>
            }
            footerContent={<div style={{
                display: 'flex', justifyContent: 'flex-end',
                alignItems: 'center',
            }}>
                <Modal
                    title={'审核结果'}
                    open={modalVisible === 'scbs'}
                    onCancel={handleModalClose}
                    okText="保存"
                    cancelText="取消"
                    footer={null}
                >
                    <ShEditor onChange={saveSuccess} >
                            <div>审核备注1：{editingRecord?.audit_comment1 || '无'}</div>
                            <div>审核备注2：{editingRecord?.audit_comment2 || '无'}</div>
                            <div>审核备注3：{editingRecord?.audit_comment3 || '无'}</div>
                    </ShEditor>
                </Modal>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                    onChange={onPageChange}
                    pageSizeOptions={pageSizeOptions}
                />
            </div>}
        />
    )
}


export default Tbsh;
